/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Huboverviewtitle2Inputs */

const id_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikhtisar`)
};

const ms_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambaran Keseluruhan`)
};

const da_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversigt`)
};

const de_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übersicht`)
};

const en_us2_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overview`)
};

const es_es2_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const es_mx2_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen`)
};

const fil_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pangkalahatang-ideya`)
};

const fr_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aperçu`)
};

const it_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panoramica`)
};

const hu_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Áttekintés`)
};

const nl_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overzicht`)
};

const no_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oversikt`)
};

const pl_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przegląd`)
};

const pt_br2_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const pt_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visão geral`)
};

const ro_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prezentare generală`)
};

const fi_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiskatsaus`)
};

const sv_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Översikt`)
};

const vi_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng quan`)
};

const tr_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel Bakış`)
};

const cs_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přehled`)
};

const bg_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Общ преглед`)
};

const ru_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор`)
};

const uk_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Огляд`)
};

const ar_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نظرة عامة`)
};

const hi_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अवलोकन`)
};

const th_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ภาพรวม`)
};

const ja_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概要`)
};

const zh_cn2_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概览`)
};

const zh_hant1_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`概覽`)
};

const ko_sandboxes_huboverviewtitle2 = /** @type {(inputs: Sandboxes_Huboverviewtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개요`)
};

/**
* | output |
* | --- |
* | "Overview" |
*
* @param {Sandboxes_Huboverviewtitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_huboverviewtitle2 = /** @type {((inputs?: Sandboxes_Huboverviewtitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Huboverviewtitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_huboverviewtitle2(inputs)
	if (locale === "ms") return ms_sandboxes_huboverviewtitle2(inputs)
	if (locale === "da") return da_sandboxes_huboverviewtitle2(inputs)
	if (locale === "de") return de_sandboxes_huboverviewtitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_huboverviewtitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_huboverviewtitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_huboverviewtitle2(inputs)
	if (locale === "fil") return fil_sandboxes_huboverviewtitle2(inputs)
	if (locale === "fr") return fr_sandboxes_huboverviewtitle2(inputs)
	if (locale === "it") return it_sandboxes_huboverviewtitle2(inputs)
	if (locale === "hu") return hu_sandboxes_huboverviewtitle2(inputs)
	if (locale === "nl") return nl_sandboxes_huboverviewtitle2(inputs)
	if (locale === "no") return no_sandboxes_huboverviewtitle2(inputs)
	if (locale === "pl") return pl_sandboxes_huboverviewtitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_huboverviewtitle2(inputs)
	if (locale === "pt") return pt_sandboxes_huboverviewtitle2(inputs)
	if (locale === "ro") return ro_sandboxes_huboverviewtitle2(inputs)
	if (locale === "fi") return fi_sandboxes_huboverviewtitle2(inputs)
	if (locale === "sv") return sv_sandboxes_huboverviewtitle2(inputs)
	if (locale === "vi") return vi_sandboxes_huboverviewtitle2(inputs)
	if (locale === "tr") return tr_sandboxes_huboverviewtitle2(inputs)
	if (locale === "cs") return cs_sandboxes_huboverviewtitle2(inputs)
	if (locale === "bg") return bg_sandboxes_huboverviewtitle2(inputs)
	if (locale === "ru") return ru_sandboxes_huboverviewtitle2(inputs)
	if (locale === "uk") return uk_sandboxes_huboverviewtitle2(inputs)
	if (locale === "ar") return ar_sandboxes_huboverviewtitle2(inputs)
	if (locale === "hi") return hi_sandboxes_huboverviewtitle2(inputs)
	if (locale === "th") return th_sandboxes_huboverviewtitle2(inputs)
	if (locale === "ja") return ja_sandboxes_huboverviewtitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_huboverviewtitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_huboverviewtitle2(inputs)
	return ko_sandboxes_huboverviewtitle2(inputs)
});
export { sandboxes_huboverviewtitle2 as "sandboxes.hubOverviewTitle" }